import type { AuthMeResponse } from "@/types/user";

import { api, unwrap } from "./axiosConfig";

export const authService = {
  async me(): Promise<AuthMeResponse> {
    return unwrap(api.get("/api/v1/auth/me"));
  },

  /**
   * Logs in. Returns `{ mfa_required: true }` when the backend replies 200 with
   * an MFA challenge (session NOT yet emitted — caller must run the 2nd factor
   * via mfaService.verify). Returns `{ mfa_required: false }` on the plain 204
   * path (session already emitted).
   */
  async login(email: string, password: string): Promise<{ mfa_required: boolean }> {
    const res = await api.post("/api/v1/auth/login", { email, password });
    const mfaRequired = res.status === 200 && res.data?.data?.mfa_required === true;
    return { mfa_required: mfaRequired };
  },

  async logout(): Promise<void> {
    await api.post("/api/v1/auth/logout");
  },

  async forgotPassword(email: string): Promise<void> {
    await api.post("/api/v1/auth/forgot-password", { email });
  },

  async resetPassword(token: string, newPassword: string): Promise<void> {
    await api.post("/api/v1/auth/reset-password", { token, new_password: newPassword });
  },
};
